import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-e7c34bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = ["to"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Logout")
  ])
], -1))

import { computed, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

import HomeIcon from "@/components/icons/HomeIcon.vue";
import CalendarIcon from "@/components/icons/CalendarIcon.vue";
import MessagesIcon from "@/components/icons/MessagesIcon.vue";
import ListIcon from "@/components/icons/ListIcon.vue";
import BedScribeIcon from "@/components/icons/BedScribeIcon.vue";
import ProfileIcon from "@/components/icons/ProfileIcon.vue";
import SettingsIcon from "@/components/icons/SettingsIcon.vue";
import ImageNotSupportedIcon from "@/components/icons/ImageNotSupportedIcon.vue";

import type { RouteRecordNormalized } from "vue-router";

interface IRoute extends RouteRecordNormalized {
  meta: {
    navItem: boolean;
    navItemImage: string;
    navItemIcon: string;
    navItemSort: number;
    navItemEnabled: boolean;
    name: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const activeLinkSelected = ref<string>();

watch(
  () => route.path,
  (path: string) => {
    activeLinkSelected.value = path;
  }
);

const routes = computed(() => {
  let arrRoutes = router.getRoutes() as IRoute[];

  arrRoutes = arrRoutes.filter(function (objRoute) {
    return objRoute.meta.navItem;
  });

  arrRoutes.sort(function (routeA, routeB) {
    return routeA.meta.navItemSort - routeB.meta.navItemSort;
  });

  return arrRoutes;
});

const isLinkActive = function (path: string) {
  return activeLinkSelected.value === path;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (route) => {
      return (_openBlock(), _createElementBlock("div", {
        key: route.path,
        to: route.path,
        class: _normalizeClass([[{ active: isLinkActive(route.path) }], "tw-border-b-2 tw-border-r-blue-grey"])
      }, [
        (!route.meta.navItemEnabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(route.meta.navItemEnabled ? 'icon' : 'icon not-allowed')
            }, [
              (route.meta.navItemIcon === 'HomeIcon')
                ? (_openBlock(), _createBlock(HomeIcon, { key: 0 }))
                : (route.meta.navItemIcon === 'CalendarIcon')
                  ? (_openBlock(), _createBlock(CalendarIcon, { key: 1 }))
                  : (_openBlock(), _createBlock(ImageNotSupportedIcon, { key: 2 })),
              _createElementVNode("span", _hoisted_3, _toDisplayString(route.meta.name), 1)
            ], 2))
          : _createCommentVNode("", true),
        (route.meta.navItemEnabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: route.name }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(route.meta.navItemEnabled ? 'icon' : 'icon not-allowed')
                }, [
                  (route.meta.navItemIcon === 'MessagesIcon')
                    ? (_openBlock(), _createBlock(MessagesIcon, { key: 0 }))
                    : (route.meta.navItemIcon === 'ListIcon')
                      ? (_openBlock(), _createBlock(ListIcon, { key: 1 }))
                      : (route.meta.navItemIcon === 'BedScribeIcon')
                        ? (_openBlock(), _createBlock(BedScribeIcon, { key: 2 }))
                        : (route.meta.navItemIcon === 'ProfileIcon')
                          ? (_openBlock(), _createBlock(ProfileIcon, { key: 3 }))
                          : (route.meta.navItemIcon === 'SettingsIcon')
                            ? (_openBlock(), _createBlock(SettingsIcon, { key: 4 }))
                            : (_openBlock(), _createBlock(ImageNotSupportedIcon, { key: 5 })),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(route.meta.name), 1)
                ], 2)
              ]),
              _: 2
            }, 1032, ["to"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128)),
    _createVNode(_component_router_link, { to: { name: 'Logout' } }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    })
  ]))
}
}

})